import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory, QueryParams } from '@ngrx/data';
import { AddressBooksQuery } from '../models/address-books-query';
import { AddressBook } from '../models/address-book';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AddressBookService extends EntityCollectionServiceBase<AddressBook> {

    private loaded = false;

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super('AddressBook', serviceElementsFactory);
    }

    get(id: string): Observable<AddressBook> {
        return this.entityMap$.pipe(
            map((entities) => entities[id]),
            switchMap((value) => value ? of(value) : this.getByKey(id))
        );
    }

    query(query: AddressBooksQuery): Observable<AddressBook[]> {
        let params = new HttpParams()
            .set('page', query.pageNumber.toString())
            .set('itemsPerPage', query.itemsPerPage.toString());
        if (query.sortColumn) {
            params = params.set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        }
        if (query.filter) {
            params = params.set('filter', query.filter);
        }
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/addressbooks`, { headers, params });
    }

    all(): Observable<AddressBook[]> {
        if (!this.loaded) {
            this.load();
            this.loaded = true;
        }
        return this.entities$;
    }

}
